/**
 * Glitter cursor trail. Desktop pointers only, never for reduced-motion users, max ~18 sparkles
 * on screen, throttled to one per 40 ms. Purely decorative (pointer-events: none).
 */
(() => {
  if (!window.matchMedia('(pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const glyphs = ['✦', '✧', '★', '♡', '·'];
  const colors = ['var(--color-pink)', 'var(--color-violet)', 'var(--color-teal)', 'var(--color-glow)', '#fff'];
  const MAX = 18;
  let alive = 0;
  let last = 0;

  window.addEventListener('pointermove', (event) => {
    const now = performance.now();
    if (now - last < 40 || alive >= MAX) return;
    last = now;
    const s = document.createElement('span');
    s.className = 'sparkle';
    s.setAttribute('aria-hidden', 'true');
    s.textContent = glyphs[(Math.random() * glyphs.length) | 0];
    s.style.left = `${event.clientX + (Math.random() * 12 - 6)}px`;
    s.style.top = `${event.clientY + (Math.random() * 12 - 6)}px`;
    s.style.color = colors[(Math.random() * colors.length) | 0];
    s.style.fontSize = `${10 + Math.random() * 10}px`;
    alive += 1;
    s.addEventListener('animationend', () => { s.remove(); alive -= 1; }, { once: true });
    document.body.appendChild(s);
  }, { passive: true });
})();
